var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 222.624,
    height: 52,
    viewBox: "0 0 222.624 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3387",
    "data-name": "Group 3387",
    transform: "translate(-29.58 -25.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2020",
    "data-name": "Group 2020",
    transform: "translate(80.336 46.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M92.783,48.669h8.76a8.238,8.238,0,0,1,5.29,1.432,5.559,5.559,0,0,1,1.752,4.566,6.688,6.688,0,0,1-.656,3.234,5.078,5.078,0,0,1-2.073,1.954q3.3,1.281,3.3,5.357,0,6.538-7.346,6.537h-9.03Zm8.558,3.235H96.523v6.6h4.953q3.3,0,3.3-3.4Q104.777,51.9,101.341,51.9Zm.2,9.771h-5.02v6.84h5.087a4.255,4.255,0,0,0,2.781-.775,3.307,3.307,0,0,0,.926-2.662,3.009,3.009,0,0,0-1.078-2.645A4.575,4.575,0,0,0,101.543,61.675Z",
    transform: "translate(-92.783 -48.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M128.788,69.875l.944-.1L129.8,72.5a34.865,34.865,0,0,1-6.806.775q-3.74,0-5.375-2.055t-1.634-6.57q0-8.962,7.312-8.963,7.077,0,7.076,7.717l-.235,2.628H119.691a4.613,4.613,0,0,0,.91,3.066q.876.977,3.268.977T128.788,69.875ZM126.766,63.2a5.751,5.751,0,0,0-.792-3.487,3.234,3.234,0,0,0-2.679-.995,3.354,3.354,0,0,0-2.746,1.045,5.559,5.559,0,0,0-.893,3.437Z",
    transform: "translate(-96.61 -49.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M135.271,56.134h3.606l3.571,13.713h.91l3.571-13.713h3.64l-6.4,24.09h-3.606l2.022-7.243h-2.9Z",
    transform: "translate(-99.792 -49.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M157.383,57.88q1.735-2.191,5.778-2.191t5.778,2.191q1.736,2.191,1.736,6.57t-1.685,6.6q-1.685,2.223-5.829,2.223t-5.829-2.223q-1.685-2.225-1.685-6.6T157.383,57.88Zm2.746,10.951a4.086,4.086,0,0,0,6.064,0,9.321,9.321,0,0,0,.775-4.414,8.426,8.426,0,0,0-.825-4.346,4.111,4.111,0,0,0-5.964,0,8.416,8.416,0,0,0-.826,4.346A9.318,9.318,0,0,0,160.13,68.831Z",
    transform: "translate(-103.153 -49.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M181.675,72.908H178V56.061h3.638v1.045a9.38,9.38,0,0,1,4.65-1.416q3.368,0,4.6,1.9t1.229,6.284v9.03h-3.638V63.978a9.158,9.158,0,0,0-.59-3.875,2.448,2.448,0,0,0-2.409-1.146,8.354,8.354,0,0,0-3.3.674l-.505.2Z",
    transform: "translate(-106.841 -49.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M206.988,50.234q-5.054,0-5.055,3.807a3.28,3.28,0,0,0,1.163,2.914,15.477,15.477,0,0,0,4.716,1.584,11.975,11.975,0,0,1,5.037,2.055,5.2,5.2,0,0,1,1.483,4.161q0,7.177-7.446,7.177a41.662,41.662,0,0,1-6.166-.574l-1.213-.168.27-2.156a57.67,57.67,0,0,0,6.975.606q4.985,0,4.986-4.684a3.179,3.179,0,0,0-1.095-2.712,10.65,10.65,0,0,0-4.094-1.4,13.782,13.782,0,0,1-5.593-2.173q-1.651-1.331-1.651-4.464,0-6.268,7.514-6.268a41.5,41.5,0,0,1,5.9.506l1.146.169-.236,2.189A63.259,63.259,0,0,0,206.988,50.234Z",
    transform: "translate(-110.355 -47.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M233.453,70.825l.977-.1.068,1.987a48.417,48.417,0,0,1-6.57.539q-3.639,0-5.156-2.106t-1.516-6.553q0-8.861,7.041-8.861a6.441,6.441,0,0,1,5.088,1.9q1.685,1.9,1.685,5.981l-.134,1.921H223.816a6.908,6.908,0,0,0,1.011,4.144,4.131,4.131,0,0,0,3.521,1.348Q230.858,71.027,233.453,70.825Zm-.91-7.312q0-3.1-.993-4.38a3.842,3.842,0,0,0-3.235-1.281,4.145,4.145,0,0,0-3.369,1.349,6.8,6.8,0,0,0-1.162,4.312Z",
    transform: "translate(-113.976 -49.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M245.047,72.914H242.52V56.067h2.493v1.179a10.781,10.781,0,0,1,5.223-1.516q3.368,0,4.532,1.82t1.162,6.469v8.9h-2.493V64.086a11.4,11.4,0,0,0-.691-4.8q-.691-1.3-2.949-1.3a8.813,8.813,0,0,0-2.274.32,11.376,11.376,0,0,0-1.836.623l-.64.3Z",
    transform: "translate(-117.484 -49.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M269.3,57.988q-3.672,0-3.672,2.56a1.769,1.769,0,0,0,.842,1.668,14.29,14.29,0,0,0,3.84,1.01,10.239,10.239,0,0,1,4.245,1.465q1.248.944,1.248,3.538a4.393,4.393,0,0,1-1.668,3.808,8.225,8.225,0,0,1-4.869,1.212,30.527,30.527,0,0,1-4.919-.472l-1.01-.169.134-2.19a42.874,42.874,0,0,0,5.8.574,5.8,5.8,0,0,0,2.982-.624,2.248,2.248,0,0,0,1.027-2.088,2.12,2.12,0,0,0-.876-1.988,12.966,12.966,0,0,0-3.84-.995,10.139,10.139,0,0,1-4.212-1.381q-1.246-.909-1.247-3.369a4.092,4.092,0,0,1,1.735-3.638,7.527,7.527,0,0,1,4.33-1.18,35.495,35.495,0,0,1,5.155.472l.944.169-.068,2.156A43.885,43.885,0,0,0,269.3,57.988Z",
    transform: "translate(-120.878 -49.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M294.259,70.825l.977-.1.068,1.987a48.429,48.429,0,0,1-6.57.539q-3.639,0-5.155-2.106t-1.516-6.553q0-8.861,7.041-8.861a6.442,6.442,0,0,1,5.088,1.9q1.685,1.9,1.684,5.981l-.134,1.921H284.622a6.9,6.9,0,0,0,1.011,4.144,4.131,4.131,0,0,0,3.521,1.348Q291.664,71.027,294.259,70.825Zm-.91-7.312q0-3.1-.993-4.38a3.842,3.842,0,0,0-3.235-1.281,4.148,4.148,0,0,0-3.37,1.349,6.8,6.8,0,0,0-1.162,4.312Z",
    transform: "translate(-124.007 -49.227)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2021",
    "data-name": "Group 2021",
    transform: "translate(29.58 25.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M46.425,46.992l0,.147.085-.028Z",
    transform: "translate(-32.358 -29.122)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M62.916,45.955",
    transform: "translate(-35.079 -28.951)",
    fill: "#35a7cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M52.621,74.826,44.4,73.082,45.65,84.934c.336.081.675.155,1.017.217a17.807,17.807,0,0,0,18.065-7.758Z",
    transform: "translate(-32.024 -33.436)",
    fill: "#0e7e99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M69.265,63.76a17.719,17.719,0,0,0-4.229-11L58.444,64.192l-4.2,7.282,12.111,2.568q.2-.311.4-.632A17.711,17.711,0,0,0,69.265,63.76Z",
    transform: "translate(-33.649 -30.08)",
    fill: "#155f70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M39.884,43.65V32.8l-10.3-7.216V59.68h0c0,.212,0,.426.007.64.017.545.061,1.083.124,1.614L41.046,56.88l7.677-3.423Z",
    transform: "translate(-29.58 -25.586)",
    fill: "#00beeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M62.847,51.332a17.81,17.81,0,0,0-20.9-4.432l8.841,9.809,5.628,6.244,6.591-11.429C62.952,51.459,62.9,51.394,62.847,51.332Z",
    transform: "translate(-31.62 -28.836)",
    fill: "#1c3f49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M41.985,71.431,41.1,63.072,29.768,68.125c.03.248.066.494.106.739A17.809,17.809,0,0,0,43.236,83.282Z",
    transform: "translate(-29.611 -31.785)",
    fill: "#079ec0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPrimary);
export default __webpack_public_path__ + "static/media/logo-primary.2d8a271e.svg";
export { ForwardRef as ReactComponent };